import { Skeleton } from "../skeleton";
import { useMemo } from "react";

export function LoadingText({
    size = "sm",
    inline = true,
    className
}: {
    size?: "sm" | "md" | "lg";
    inline?: boolean;
    className?: string;
}) {
    const classNames = useMemo(() => {
        const names: Array<string> = [];

        if (inline) {
            names.push("inline-block min-w-[125px]");
        } else {
            names.push("block w-full");
        }

        switch (size) {
            case "sm":
                names.push("h-[1rem] lg:h-[1.375rem]");
                break;
            case "md":
                names.push("h-[1.125rem] lg:h-[1.75rem]");
                break;
            case "lg":
                names.push("h-[1.25rem] lg:h-[2rem]");
                break;
        }

        return names.join(" ");
    }, [size, inline]);

    return <Skeleton className={`${classNames} ${className}`} />;
}
